
import {apiClient} from './util';
import {AxiosPromise} from 'axios';


export default {
    unsubscribe: (token: string): AxiosPromise => apiClient.get("/messaging/notification/email/unsubscribe/" + token),
};
